<palantir-list-item [attr.aria-selected]="this.model.isSelected(this.item.id)">
  <palantir-list-item-prefix>
    @if (item.avatar.src) {
      <palantir-avatar [fallbackText]="item.title">
        <img [src]="item.avatar.src" alt="Avatar for {{ item.title }}" />
      </palantir-avatar>
    }

    @if (item.avatar.icon) {
      <palantir-avatar>
        <palantir-icon [name]="item.avatar.icon" />
      </palantir-avatar>
    }
  </palantir-list-item-prefix>

  <palantir-list-item-content class="list-item-content">
    <div class="list-item-content__text">
      <palantir-text type="title">{{ item.title }}</palantir-text>

      @if (item.subtitle) {
        <palantir-text type="description">{{ item.subtitle }}</palantir-text>
      }
    </div>

    @let suffixTag = item.suffixTag;
    @if (suffixTag) {
      <palantir-tag
        [suffix]="suffixTag.suffix"
        [prefix]="suffixTag.prefix"
        [color]="suffixTag.color"
      >
        {{ suffixTag.label }}
      </palantir-tag>
    }
  </palantir-list-item-content>

  @let disabledItemByLimit =
    limitItems() && model.selected.length >= limitItems() && !model.isSelected(this.item.id);
  @if (type === 'multiple') {
    <palantir-checkbox
      (click)="toggleItem()"
      palantir-list-item-suffix
      [attr.aria-selected]="this.model.isSelected(this.item.id)"
      [attr.disabled]="item.disabled || disabledItemByLimit"
    />
  }

  @if (type === 'single') {
    <palantir-radio
      (click)="toggleItem()"
      palantir-list-item-suffix
      [attr.aria-selected]="this.model.isSelected(this.item.id)"
      [attr.disabled]="item.disabled"
    />
  }

  @for (child of item.children; track $index) {
    <palantir-selectable-item [item]="child" [items]="items" [model]="model" [type]="type" />
  }
</palantir-list-item>
